<template>
  <div>
    <!-- Column: Common -->
    <span>
      {{ data.formattedRow[data.column.field] }}
    </span>
  </div>

</template>

<script>

export default {
  props: {
    data: {
      type: [Array, Object],
    },
  },
}
</script>
